import { cn } from '@/shadcn-ui/utils';

export interface BannerSuccessProps {
  className?: string;
}
export default function BannerSuccess({ className }: BannerSuccessProps) {
  return (
    <svg
      viewBox="0 0 30 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(`h-[38px] w-[30px]`, className)}
    >
      <g filter="url(#filter0_d_3223_6892)">
        <path
          d="M9 15C9 10.5817 12.5817 7 17 7C21.4183 7 25 10.5817 25 15V23C25 27.4183 21.4183 31 17 31C12.5817 31 9 27.4183 9 23V15Z"
          fill="url(#paint0_linear_3223_6892)"
        />
        <path
          d="M9.5 15C9.5 10.8579 12.8579 7.5 17 7.5C21.1421 7.5 24.5 10.8579 24.5 15V23C24.5 27.1421 21.1421 30.5 17 30.5C12.8579 30.5 9.5 27.1421 9.5 23V15Z"
          stroke="#10BA81"
          strokeMiterlimit="10"
        />
      </g>
      <g filter="url(#filter1_d_3223_6892)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.9472 14.1055C21.4412 14.3525 21.6414 14.9532 21.3944 15.4472L17.3944 23.4472C17.2507 23.7347 16.9775 23.9356 16.6602 23.9871C16.3429 24.0386 16.0202 23.9344 15.7929 23.7071L12.7929 20.7071C12.4024 20.3166 12.4024 19.6834 12.7929 19.2929C13.1834 18.9023 13.8166 18.9023 14.2071 19.2929L16.226 21.3118L19.6056 14.5528C19.8526 14.0588 20.4532 13.8586 20.9472 14.1055Z"
          fill="#FFF8F8"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3223_6892"
          x="0"
          y="0"
          width="30"
          height="38"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-2" />
          <feGaussianBlur stdDeviation="3.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.141176 0 0 0 0 0.658824 0 0 0 0 0.486275 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6892"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6892"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_3223_6892"
          x="8.5"
          y="11.9998"
          width="17.0002"
          height="18.0002"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_3223_6892"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3223_6892"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3223_6892"
          x1="20.1319"
          y1="30.4328"
          x2="11.6578"
          y2="11.2984"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#11CB8D" />
          <stop offset="1" stopColor="#089465" />
        </linearGradient>
      </defs>
    </svg>
  );
}
